var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53128 11.9866H7.41074C6.91788 11.9866 6.51788 12.3866 6.51788 12.8794V17.1205C6.51788 17.6134 6.91788 18.0134 7.41074 18.0134H9.53128L13.084 21.0232C13.6643 21.5152 14.5536 21.1027 14.5536 20.3419V9.65802C14.5536 8.8973 13.6634 8.4848 13.084 8.97677L9.53128 11.9866Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1581 18.5518C19.1956 17.9072 19.9108 16.5661 19.9108 15.0045C19.9108 13.4429 19.1956 12.1009 18.1581 11.4482",
    stroke: "#6F6F6F",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8081 21.3081C22.4223 19.9197 23.4822 17.6161 23.4822 15.0027C23.4822 12.3857 22.4206 10.0804 20.8036 8.69287",
    stroke: "#6F6F6F",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5L25.5 25.5",
    stroke: "#6F6F6F",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIconGrey);
export default __webpack_public_path__ + "static/media/soundIconGrey.c5131120d9e7efa160a287626bfa7ed6.svg";
export { ForwardRef as ReactComponent };